import React, { useRef } from 'react';

import cs from 'classnames';
import { capitalize } from 'lodash';

import SearchProviders from 'components/Search/SearchProviders/SearchProviders';
import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';
import Select from 'components/shared/Select/Select';
import Textarea from 'components/shared/Textarea/Textarea';

import SelectMedicationTable from './components/SelectMedicationTable';

const CurrentMedicationsRow = ({
  medication,
  sig,
  condition,
  start_date,
  end_date,
  prescriber,
  is_past,
  note,
  id,
  onChange,
  onChangeMulti,
  newDesign,
  className,
  veradigm_id,
  pharmacist_instructions
}) => {
  const noteRef = useRef(null);

  const handleSelectMedication = async (medication) => {
    onChangeMulti(
      {
        medication: capitalize(medication.generic_name || medication.brand),
        dosage_form: medication.dosage_form,
        route: medication.route,
        product_ndc: medication.product_ndc,
        product_ndc_id: medication.product_id
      },
      id
    );
  };
  const disabled = veradigm_id ? true : false;
  return (
    <div>
      {!disabled && (
        <SelectMedicationTable
          newDesign={newDesign}
          onChange={onChange}
          medication={medication}
          id={id}
          handleSelectMedication={handleSelectMedication}
        />
      )}
      <div className={cs('flex items-center gap-x-[10px]', className?.replace('dashed-top', ''))}>
        <div className="grid w-full gap-4">
          <div className={cs(newDesign ? 'grid-cols-1' : 'grid-cols-2', 'grid  gap-4')}>
            <Textarea
              className="sm:col-span-full md:col-span-full"
              data-qa="add-sig"
              label="List the dosage and how often"
              placeholder="e.g. 1 pill every 4 hours"
              name="sig"
              value={sig}
              onChange={(event) => onChange('sig', event.target.value, id)}
              disabled={disabled}
              transcribing
              forwardedRef={noteRef}
              textareaClassName="!min-h-[60px]"
            />

            <div
              className={cs(
                is_past ? 'grid-cols-2' : 'grid-cols-1',
                'grid gap-4 sm:col-span-full sm:grid-cols-[repeat(auto-fit,minmax(130px,1fr))] md:col-span-full'
              )}>
              <DateInputPicker
                label="Date started"
                isDateOnly
                value={start_date}
                onChange={(val) => onChange('start_date', val, id)}
                disabled={disabled}
              />
              {is_past && (
                <DateInputPicker
                  label="Date ended"
                  isDateOnly
                  value={end_date}
                  onChange={(val) => onChange('end_date', val, id)}
                  disabled={disabled}
                />
              )}
            </div>

            <Select
              inputId="select-condition"
              label="Condition"
              id="condition"
              value={condition}
              name="condition"
              onChange={(event) => onChange('condition', event, id)}
              isCreatable
              isClearable
              isMulti
              placeholder="Type and select condition"
              disabled={disabled}
            />

            <SearchProviders
              label="Prescriber"
              id="prescribingPhysician"
              placeholder="Prescriber"
              disabled={disabled}
              value={prescriber}
              onChange={(event) => onChange('prescriber', event, id)}
            />

            {!!veradigm_id && (
              <div className={cs(newDesign ? 'grid-cols-1' : 'grid-cols-2', 'grid  gap-4')}>
                <Textarea
                  className="sm:col-span-full md:col-span-full"
                  data-qa="add-pharmacist-note"
                  label="Special instructions to pharmacist"
                  placeholder="Add pharmacist note here"
                  name="pharmacist_note"
                  value={pharmacist_instructions}
                  onChange={(event) => onChange('pharmacist_note', event.target.value, id)}
                  disabled={disabled}
                  transcribing
                  forwardedRef={noteRef}
                  textareaClassName="!min-h-[60px]"
                />
              </div>
            )}

            <Textarea
              className="sm:col-span-full md:col-span-full"
              data-qa="add-note"
              label="Notes"
              placeholder="Add note here"
              name="note"
              value={note}
              onChange={(event) => onChange('note', event.target.value, id)}
              disabled={disabled}
              transcribing
              forwardedRef={noteRef}
              textareaClassName="!min-h-[60px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentMedicationsRow;
